import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="page-footer font-small mdb-color pt-4">
      <div className="container text-center text-md-left">
        <div className="row d-flex align-items-baseline">
          <div className="col-md-7 col-lg-8">
            <p className="text-center text-md-left">
              <small>Copyright © 2020 WMT All rights reserved.</small>
            </p>
          </div>
          <div className="col-md-5 col-lg-4 ml-lg-0 text-right">
            <a className="footer__link" href="/privacy">
              Privacy policy
            </a>
            {/* <div className="text-center text-md-right">
                <ul className="list-unstyled list-inline">
                    <li className="list-inline-item"><a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light" href="javascript:void(0);">
                        <i className="fa fa-facebook"></i></a></li>
                    <li className="list-inline-item"><a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light" href="javascript:void(0);"><i className="fa fa-twitter"></i></a></li>
                    <li className="list-inline-item"><a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light" href="javascript:void(0);"><i className="fa fa-instagram"></i></a></li>
                    <li className="list-inline-item"><a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light" href="javascript:void(0);"><i className="fa fa-google-plus"></i></a></li>
                    <li className="list-inline-item"><a className="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light" href="javascript:void(0);"><i className="fa fa-envelope"></i></a></li>
                </ul>

            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
